import React from "react";
import {useNavigate} from "react-router-dom";
import {Button} from "antd";

import "./MembershipHeader.less";

const MembershipHeader = ({memberNumber}: {memberNumber: string}) => {
    const navigate = useNavigate();
    return (
        <div className="membership-header">
            <Button
                size="small"
                type={memberNumber ? "link" : "default"}
                onClick={() => navigate('/member_change')}
            >
                {!memberNumber ? "Select Member" : memberNumber}
            </Button>
        </div>
    );
}

export default MembershipHeader;
